import React, { useRef } from 'react';
import './Join.css';
import emailjs from '@emailjs/browser';

const Join = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        'service_f0ebopc',
        'template_m6ddlun',
        form.current,
        'H38ZkW7YJs-d2UNKI'
      )
      .then(
        () => {
          console.log('SUCCESS!');
          alert('Registration Successful! We will get back to you soon.');
          form.current.reset();
        },
        (error) => {
          console.log('FAILED...', error.text);
          alert('Failed to send. Please try again later.');
        }
      );
  };

  return (
    <div className='Join' id='join-us'>
      <div className="left-j">
        <hr />
        <div>
          <span className='stroke-text'>READY TO</span>
          <span>LEVEL UP</span>
        </div>
        <div>
          <span>YOUR BODY</span>
          <span className='stroke-text'>WITH US?</span>
        </div>
      </div>
      <div className="right-j">
        <form ref={form} className="email-container" onSubmit={sendEmail}>
          <input 
            type="text" 
            name="user_name" 
            placeholder='Your Name'
            required
          />
          <input 
            type="email" 
            name="user_email" 
            placeholder='Your Email'
            required
          />
          <input 
            type="tel" 
            name="user_phone" 
            placeholder='Phone Number'
            required
          />
          <button type="submit" className='btn btn-j'>Join Now</button>
        </form>
      </div>
    </div>
  );
};

export default Join;